import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Checkbox } from 'antd';

import background_circle_green from 'images/background_circle_green_modal.svg';
import icons_arrow_left_right from 'images/icons_arrow_left_right.svg';
import { AppContext } from 'context/AppContext';

import icon_arrow_left_bgc_dark from 'images/icon_arrow_left_bgc_dark.svg';
import icon_arrow_right_bgc_dark from 'images/icon_arrow_right_bgc_dark.svg';
import click_here_to_exit from 'images/modal/click_here_to_exit.svg';
import icon_close from 'images/modal/icon_close.svg';
import nav_left_myproject from 'images/modal/nav_left_myprojects.svg';
import nav_left_stats from 'images/modal/nav_left_stats.svg';
import nav_left_transform from 'images/modal/nav_left_transform.svg';
// import { saveDefaults } from 'services/login';

// import { useNavigate } from "react-router-dom";

const CartsAndTableView = () => {
    // const navigate = useNavigate()
    let appContext = useContext(AppContext);

    const [isModalVisibleChartsTable, setIsModalVisibleChartsTable] =
        useState(false);

    const [isModalVisibleChart, setIsModalVisibleChart] = useState(false);
    const [isModalVisibleTable, setIsModalVisibleTable] = useState(true);

    const showModalChartsTable = () => {
        setIsModalVisibleChartsTable(true);
    };

    const handleOkChartsTable = () => {
        setIsModalVisibleChartsTable(false);
        // saveDefaults({ name: 'onboarding_project', value: 'finishhh' });
        appContext.setDefault('onboarding_project', 'finish');
    };

    const handleBackChartsTable = () => {
        setIsModalVisibleChartsTable(false);
        setIsModalVisibleChart(true);
    };

    const handleCancelChartsTable = () => {
        setIsModalVisibleChartsTable(false);
    };

    const showModalChart = () => {
        setIsModalVisibleChart(true);
    };

    const handleOkChart = () => {
        setIsModalVisibleChart(false);
        setIsModalVisibleChartsTable(true);
    };

    const handleBackChart = () => {
        setIsModalVisibleChart(false);
        setIsModalVisibleTable(true);
    };

    const handleCancelChart = () => {
        setIsModalVisibleChart(false);
    };

    const showModalTable = () => {
        setIsModalVisibleTable(true);
    };

    const handleOkTable = () => {
        setIsModalVisibleTable(false);
        setIsModalVisibleChart(true);
    };

    const handleBackTable = () => {
        setIsModalVisibleTable(false);
    };

    const handleCancelTable = () => {
        setIsModalVisibleTable(false);
    };

    // if (isModalVisibleTable) {
    //     document.addEventListener('keyup', (e) => {
    //         if (e.keyCode === 39) {
    //             setIsModalVisibleTable(false);
    //             setIsModalVisibleChartsTable(false);
    //             setIsModalVisibleChart(true);
    //         }
    //     });
    // }
    // if (isModalVisibleChart) {
    //     document.addEventListener('keyup', (e) => {
    //         if (e.keyCode === 39) {
    //             setIsModalVisibleChart(false);
    //             setIsModalVisibleTable(false);
    //             setIsModalVisibleChartsTable(true);
    //         } else if (e.keyCode === 37) {
    //             setIsModalVisibleChartsTable(false);
    //             setIsModalVisibleChart(false);
    //             setIsModalVisibleTable(true);
    //         }
    //     });
    // }
    // if (isModalVisibleChartsTable) {
    //     document.addEventListener('keyup', (e) => {
    //         if (e.keyCode === 37) {
    //             setIsModalVisibleChartsTable(false);
    //             setIsModalVisibleTable(false);
    //             setIsModalVisibleChart(true);
    //         }
    //     });
    // }

    return (
        <>
            <Modal
                className="custom-modal-tutorial-table"
                visible={isModalVisibleTable}
                onOk={handleOkTable}
                onCancel={handleCancelTable}
                footer={null}
                closable={false}
                bodyStyle={{ height: '193px' }}
                width={302}
            >
                <div className="tutorial-container-table">
                    {/* <div className="nav-left">
                        <img src={nav_left_transform} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Data Matrix View</div>
                        <div className="icon-close">
                            <img onClick={handleCancelTable} src={icon_close} />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            This is the default view when you <br />
                            upload your data. The entire screen <br />
                            is used to view the data frame.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackTable();
                            }}
                        >
                            BACK
                        </div>
                        <div className="step">Step 1 of 3</div>
                        <div onClick={handleOkTable} className="button-next">
                            NEXT
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                className="custom-modal-tutorial-charts"
                visible={isModalVisibleChart}
                onOk={handleOkChart}
                onCancel={handleCancelChart}
                footer={null}
                closable={false}
                bodyStyle={{ height: '193px' }}
                width={302}
            >
                <div className="tutorial-container-charts">
                    {/* <div className="nav-left">
                        <img src={nav_left_stats} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Analysis View</div>
                        <div className="icon-close">
                            <img onClick={handleCancelChart} src={icon_close} />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            This view will hide the data frame <br />
                            and use the entire screen to display <br />
                            the results of your analyses.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackChart();
                            }}
                        >
                            BACK
                        </div>

                        <div className="step">Step 2 of 3</div>
                        <div onClick={handleOkChart} className="button-next">
                            NEXT
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                className="custom-modal-tutorial-charts-table"
                visible={isModalVisibleChartsTable}
                onOk={handleOkChartsTable}
                onCancel={handleCancelChartsTable}
                footer={null}
                closable={false}
                bodyStyle={{ height: '193px' }}
                width={302}
            >
                <div className="tutorial-container-charts-table">
                    {/* <div className="nav-left">
                        <img src={nav_left_myproject} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Multi View</div>
                        <div className="icon-close">
                            <img
                                onClick={handleCancelChartsTable}
                                src={icon_close}
                            />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            This view allows you to see both <br />
                            the results from your analyses and <br />
                            the data frame.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackChartsTable();
                            }}
                        >
                            BACK
                        </div>

                        <div className="step">Step 3 of 3</div>
                        <div
                            onClick={handleOkChartsTable}
                            className="button-next"
                        >
                            FINISH
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default CartsAndTableView;
